// extracted by mini-css-extract-plugin
module.exports = {"root":"rtl-plus-event_root__yvSie"};